import { YourIR } from 'yourir-next';

export default function AsxCorporateGovernanceDocs(props)
{
    const { className } = props;

    return (
        <YourIR>
            <div className={ "sol-markdown-content" + ( className ? " " + className : "" ) }>
                <h6>Corporate Governance Statements</h6>
                <ul className="text-light/50" data-yourir="announcements search='Corporate Governance Statement' pageSize=1">
                    <li className="mb-2">
                        <a className="no-underline hover:underline cursor-pointer" target="__target">
                            Corporate Governance Statement (<span data-yourir="$cur.date format='YYYY'"></span>)
                        </a>
                    </li>
                </ul>
            </div>
        </YourIR>
    );
}